import {IdName} from "../common/types/IdName";

export const formatSelectOptions = (options: IdName[]) => {
    return options.map(option => {
        return {key: option.id, value: option.id, text: option.name}
    })
}